export enum ThirdPartyReferenceType {
    /** 0 */
    UNKNOWN_THIRD_PARTY_REFERENCE_TYPE = 'UNKNOWN_THIRD_PARTY_REFERENCE_TYPE',
    /** 1 */
    FACTORSOFT = 'FACTORSOFT',
    /** 2 */
    AMAZON_COGNITO = 'AMAZON_COGNITO',
    /** 3 */
    APPLY = 'APPLY',
    /** 4 */
    ENROLLMENT = 'ENROLLMENT',
    /** 5 */
    FINANCING_SELLER = 'FINANCING_SELLER',
    /** 6 */
    FINANCING_BUYER = 'FINANCING_BUYER',
    /** 7 */
    ADMINISTRATION = 'ADMINISTRATION',
    /** 8 */
    FINANCING_ACCOUNT = 'FINANCING_ACCOUNT',
    /** 9 */
    PROSPECT = 'PROSPECT'
}
